import React from 'react';
import { UtilityBar } from '../components/UtilityBar';
import { SiteHeader } from '../components/SiteHeader/SiteHeader';
import { HeroSection } from '../components/HeroSection';
import { TrustStrip } from '../components/TrustStrip';
import { ServicesSection } from '../components/ServicesSection';
import { WorkGallery } from '../components/WorkGallery';
import { FleetSection } from '../components/FleetSection';
import { ProcessSection } from '../components/ProcessSection';
import { AboutSection } from '../components/AboutSection';
import { FaqSection } from '../components/FaqSection';
import { ContactSection } from '../components/ContactSection';
import { SiteFooter } from '../components/SiteFooter';
export function Home() {
  return <div id="top" className="min-h-screen w-full bg-paper font-sans text-ink" data-id="element-260" data-mp="2dj1nevys5l9j">
      <a href="#main" className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[60] focus:bg-ink focus:px-4 focus:py-3 focus:text-paper" data-id="element-261" data-mp="3kuil9p1nz2bl">
        Skip to content
      </a>
      <UtilityBar data-id="element-262" data-mp="30w02vw8itc1x" />
      <SiteHeader data-id="element-263" data-mp="2vxovrt9m1fne" />
      <main id="main" data-id="element-264" data-mp="2vx6qy88vtt3v">
        <HeroSection data-id="element-265" data-mp="2vyq8e269ya78" />
        <TrustStrip data-id="element-266" data-mp="2vyhty5ui6wtx" />
        <ServicesSection data-id="element-267" data-mp="2vvvnk9jcmnda" />
        <WorkGallery data-id="element-268" data-mp="2qy2i5ipvdxe2" />
        <FleetSection data-id="element-269" data-mp="2qxkei10vogw4" />
        <ProcessSection data-id="element-270" data-mp="2qwsgkjjt672o" />
        <AboutSection data-id="element-271" data-mp="2r0gctqgn17l3" />
        <FaqSection data-id="element-272" data-mp="2mxjmteorq974" />
        <ContactSection data-id="element-273" data-mp="2mvyulvpxf2cf" />
      </main>
      <SiteFooter data-id="element-274" data-mp="2mz3335afck8w" />
    </div>;
}